/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-touch-2': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.125 9.375h-1.25a6.875 6.875 0 10-13.75 0h-1.25a8.125 8.125 0 0116.25 0zm-2.5 8.125h-1.25V9.375a4.375 4.375 0 10-8.75 0V17.5h-1.25V9.375a5.625 5.625 0 1111.25 0V17.5zm-2.5-5h-6.25V9.375a3.125 3.125 0 016.25 0V12.5zm-5-1.25h3.75V9.375a1.875 1.875 0 00-3.75 0v1.875z"/>'
  }
})
